module.exports = __webpack_public_path__ + "img/blue_club_benefits_img.590f8524.png";